import { ajax } from "discourse/lib/ajax";
import DiscourseRoute from "discourse/routes/discourse";

export default class AdminPluginsShowCommunityNavigationStructureRoute extends DiscourseRoute {
  model() {
    return ajax("/admin/plugins/community-navigation/structure.json");
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.structure = model;
  }
}
